module.exports = __webpack_public_path__ + "img/modal-go-to-app@2x.bcf5c2f6.png";